(function () {
    'use strict';

    angular.module("imApp").factory("activityTypeDevTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1234,
                    parameters: parms || {}
                });
            },
            listDeviationTypes: function (parms) {
                return $ihttp.post({
                    method: 1235,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
